module.exports = __webpack_public_path__ + "img/icon-english-2.634628a7.png";